import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import { Alert } from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import accountManagement from '../../../../../apis/accountManagement';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';
import Select from 'react-select';

import ReactExport from "react-data-export";

import DropdownProvinsi from '../../masterDropDown/DropdownProvinsi';
import DropdownKota from '../../masterDropDown/DropdownKota';
import DropdownKodeJenjangSekolah from '../../masterDropDown/DropdownKodeJenjangSekolah';

class ImportSekolah extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            error: null,
            resMessage: '', 
            alertShow: false,          
            isFetching: false,
            file: '',
            listProvinsi : [],
            listKota : [],
            dataUser : null,
            idProvinsi: null,
            idKabKota: null,
            kodeJenangSekolah: null,
            isPsep: null
        }
    }

    async componentDidMount(){
        console.clear();
        this.setState({isFetching: true});
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
        }     
    } 
     
    fetchProvinsi = async()=>{
        this.setState({isFetching:true})     
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {})
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                // this.setState({
                //     provinsi: respons.data.list_provinsi
                // })
                const dataProvinsi = {value : '', label: 'Pilih Provinsi...', id:'idProvinsi', selected: 'selected'}
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i)=>{
                    const dataProvinsi = {value : val.ID_PROVINSI, label: val.NAMA_PROVINSI, id:'idProvinsi'}
                    this.state.listProvinsi.push(dataProvinsi);

                })
            }
        }
        this.setState({isFetching:false}) 
    }

    onFileChange = (event) => {        
		this.setState({
			file: event.target.files[0], dataUser: null, alertShow: false
		});
    }

    handleChangeKodeJenjang = async (e)=>{this.setState({ kodeJenangSekolah: e.target.value });}

    handleChangeIsPsep = async (e)=>{this.setState({ isPsep: e.target.value });}

    handleSubmit = async (event)=> {
        event.preventDefault();
        if (this.state.isFetching) return;
        this.setState({isFetching:true, dataUser:null, alertShow:false, keterangan:''});
        try {
        if(this.state.file && this.state.file.size < 1000000 ){
            let data = new FormData();           
            data.append('file', this.state.file);
            data.append('idProvinsi', this.state.idProvinsi);
            data.append('idKabKota', this.state.idKabKota);
            data.append('kodeJenjangSekolah', this.state.kodeJenangSekolah);
            data.append('isPsep', this.state.isPsep);
            const response = await akmApi.post(URL_AKM.IMPORT_SEKOLAH,
                data 
            );
            if(!response || !response.data || !response.data.errorSchema || !response.data.data) throw new Error('Balasan impor tidak tersedia');
            if (response.data.errorSchema.errorCode !== URL_AKM.SUCCESS_ERROR_CODE || !Array.isArray(response.data.data.dataUser)) {
                this.setState({alertShow:true, keterangan:'Impor sekolah ditolak. Periksa format berkas dan pilihan wilayah.'});
            } else {
                this.setState({
                    resMessage: response.data.errorSchema,
                    alertShow:true,
                    dataUser: response.data.data.dataUser.length ? response.data.data.dataUser : null,
                    keterangan: response.data.data.keterangan || 'Impor sekolah selesai.',
                    file: ''
                });
                const fileInput = document.getElementById("file");
                if (fileInput) fileInput.value = "";
            }           
            
        }else{
            this.setState({
                resMessage: 'File Dokumen harus < 1Mb ..!!',
                keterangan: 'Pilih dokumen sekolah berukuran kurang dari 1 MB.',
                alertShow:true,
                isFetching: false
            });
        }
        } catch (error) {
            this.setState({alertShow:true, dataUser:null, keterangan:'Hasil impor belum dapat dikonfirmasi. Periksa daftar sekolah sebelum mengirim ulang.'});
        } finally {
            this.setState({isFetching:false});
        }
    }

    resetState = async () =>{
        this.setState({ 
            idProvinsi : '',
            idKabKota : '',
            isPsep: '',
            kodeJenangSekolah : '',
            dataUser : []  
        });
    }


    handleChangeSelect = async e => {
        const name = e.id;
        const id = e.value;
        this.setState({ 
            [e.id]: id,
            isFetching : true
        });
        
        if(name == 'idProvinsi'){
            const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA+id, {})
            if (respons) {
                if (!__.isEmpty(respons.data.list_kab_kota)) {
                    const data = {value : '', label: 'Pilih Kota...', id:'idKabKota', selected: 'selected'}
                    this.state.listKota.push(data);
                    respons.data.list_kab_kota.map((val, i )=>{
                        const data = {value : val.ID_KABUPATEN_KOTA, label: val.NAMA_KABUPATEN_KOTA, id:'idKabKota'}
                        this.state.listKota.push(data);
                    })
                }
            }
        }
        this.setState({ isFetching : false });
    };

    render() {                 
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        const {error, isFetching, listProvinsi, listKota, idProvinsi, idKabKota, kodeJenangSekolah, isPsep, dataUser} = this.state;
        if(error){
            return (
                <div>Error: {error.message}</div>
              )
        } 
        return (
            <div className="wrapper">
            <LoaderModal isFetching={isFetching} />
            <Sidebar account={this.props.account}/>
            <div id="content" style={{paddingBottom: '50px'}}>
                <Navbar />  
                <div className="row">
                    <div className="col-md-12">
                        <h4>UPLOAD SEKOLAH</h4>
                    </div>                         
                </div>
                {this.loadAlert()}   
                <div className="row">
                    <div className="col-md-5">
                        <div class="card">
                            <div class="card-body">
                                <form onSubmit={this.handleSubmit}>                                        
                                    {/* <div className="form-group">
                                        <label><span className="text-danger">*</span>Provinsi </label>
                                        <select className="form-control" name="idProvinsi" id="idProvinsi" 
                                            value={idProvinsi}
                                            onChange={this.handleProvinsiOnChange} required>
                                            <option value="" disabled selected>Pilih Provinsi...</option>
                                            <DropdownProvinsi provinsi={provinsi}/>
                                        </select>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Kabupaten / Kota </label>
                                        <select className="form-control" name="idKota" id="idKota" 
                                            value={idKabKota}
                                            onChange={this.handleKotaOnChange} required>
                                            <option value="" disabled selected>Pilih Kota...</option>
                                            <DropdownKota kota={kota}/>
                                        </select>
                                    </div>
                                    
                                    */}    
                                    <Fragment>    
                                        <Select 
                                            options={listProvinsi}
                                            onChange={this.handleChangeSelect}
                                            placeholder ="Pilih Provinsi..."
                                        />
                                        <input
                                            tabIndex={-1}
                                            autoComplete="off"
                                            style={{ opacity: 0, height: 0 }}
                                            value={idProvinsi}
                                            required
                                        />
                                    </Fragment>

                                    <Fragment>    
                                        <Select 
                                            options={listKota}
                                            onChange={this.handleChangeSelect}
                                            placeholder ="Pilih Kabupaten / Kota..."
                                        />
                                        <input
                                            tabIndex={-1}
                                            autoComplete="off"
                                            style={{ opacity: 0, height: 0 }}
                                            value={idKabKota}
                                            required
                                        />
                                    </Fragment>        

                                              

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Jenjang Sekolah</label>
                                        <select className="form-control" name="kodeJenjangSekolah" id="kodeJenjangSekolah" 
                                            value={kodeJenangSekolah}
                                            onChange={this.handleChangeKodeJenjang} required >
                                            <option value="" disabled selected>Pilih Kode Jenjang...</option>
                                            <DropdownKodeJenjangSekolah />
                                        </select>
                                    </div>       

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Tipe Sekolah</label>
                                        <select className="form-control" name="isPsep" id="isPsep" 
                                            value={isPsep}
                                            onChange={this.handleChangeIsPsep} required >
                                            <option value="" disabled selected>Pilih Tipe Sekolah...</option>
                                            <option value="1" >PSEP</option>
                                            <option value="0" >Bukan PSEP</option>
                                        </select>
                                    </div>  

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Pilih File: </label>
                                        <input type="file" className="form-control" required 
                                        onChange={this.onFileChange} id="file"
                                        accept=".xlsx" />
                                    </div>
                                    <br />
                                    <button type="submit" value="Submit" className="btn btn-primary">
                                        <li className="fa fa-upload"> Upload</li>
                                    </button>
                                    &nbsp;  
                                    {dataUser != null &&
                                        <ExcelFile element={<button className="btn btn-info" >Download Data</button>} filename="Username Sekolah" onClick={() => this.resetState}>
                                            <ExcelSheet data={dataUser} name="Username Sekolah">
                                                <ExcelColumn label="Nama Sekolah" value="namaAdminUser"/>
                                                <ExcelColumn label="Username" value="usernameAdmin"/>
                                                <ExcelColumn label="Password" value="passwordAdmin"/>
                                            </ExcelSheet>

                                        </ExcelFile>
                                    }
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div class="card">
                            <div class="card-body">
                                <h5>Prosedur Upload Sekolah :</h5>
                                <ol>
                                    <li>Download format dokumen (.xlsx)&nbsp;</li>
                                    <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                                    <li>Format dokumen wajib&nbsp;<span class="text-danger"><strong>*</strong></span><strong>.xlsx</strong><span class="text-danger"><strong>*</strong></span></li>
                                    <li>Username akan di ambil 1 kata paling awal, disertai dengan <strong>psep</strong> di depan username (psepsmaedu).</li>
                                    <li>Password awal dibuat acak. Unduh akun baru melalui Download Data dan simpan dengan aman.</li>
                                    <li>PASTIKAN TIDAK ADA IMPORT FILE LEBIH DARI 1 KALI, KARENA AKAN MENYEBABKAN DUPLIKASI SEKOLAH!!</li>
                                    <br/>
                                    <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + '/FORM_IMPORT_SEKOLAH.xlsx'}><li className="fa fa-download"> Download</li></a>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
        );
    }


    loadAlert = () => {
        const {alertShow,keterangan } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{keterangan}</strong>
            </Alert>
          );
        } 
    }
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(ImportSekolah);
